import { createSlice } from "@reduxjs/toolkit";
import type { TemplateModel } from "../../../models/template";

const initialState = {
  loading: false,
  data: null as TemplateModel | null,
  error: null,
};

const dataSlice = createSlice({
  name: "create-model",
  initialState: initialState,
  reducers: {
    initCreateModel: () => {
      return { ...initialState };
    },
    startCreateModel: (state) => {
      state.loading = true;
    },
    successCreateModel: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    errorCreateModel: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  initCreateModel,
  startCreateModel,
  successCreateModel,
  errorCreateModel,
} = dataSlice.actions;

export default dataSlice.reducer;
